import React, {useState} from 'react'
import { DataProvider } from '../Data'
import Content from './Content'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
// import { ThemeProvider } from '@material-ui/styles';
import Notification from '../Common/Notification';
import {utils} from '../Helpers/auth';

const theme = createMuiTheme({
// const theme = {
  palette: {
    primary: {
      light: '#6e7991',
      main: '#424d63',
      dark: '#192539',
      contrastText: '#fff',
    },
  },
// };
});

export const MainContext = React.createContext();

export default function App (props) {
  const [ user, setUser ] = useState(utils.getPayloadFromToken())
  const [ notification, setNotification ] = useState()
  return (
    <MainContext.Provider value={{
      user, setUser, notification, setNotification
    }}>
      <DataProvider user={user}>
        <MuiThemeProvider theme={theme}>
        {/* <ThemeProvider theme={{
          palette: {
            primary: {
              light: '#6e7991',
              main: '#424d63',
              dark: '#192539',
              contrastText: '#fff',
            },
          }
        }}> */}
        {/* <ThemeProvider theme={theme}> */}
          <Content />
        {/* </ThemeProvider> */}
        </MuiThemeProvider>
      </DataProvider>
      <Notification 
        notification={notification}
        setNotification={setNotification}
      />
    </MainContext.Provider>
  )
}
